angular.module('ccs').directive('canvasPaint', canvasPaint)

function canvasPaint() {
  return {
    restrict: 'E',
    templateUrl: 'app/views/common/canvas_paint.html',
    scope: {
      saveEvent: '&',
      clearEvent: '&',
    },
    link: function ($scope) {
      /**
       * Basic Canvas Paint
       * Copyright (c) 2018-2021 Alexandre Bobkov
       * Github - https://github.com/bobkovalex/Basic-Canvas-Paint
       * Demo - https://www.jqueryscript.net/other/Drawing-Signature-App-jQuery-Canvas.html
       * Licensed under MIT
       * @author Alexandre Bobkov
       * @version 0.7.3
       */

      // Unsubscribe from all events for canvas
      $scope.$on('$destroy', function () {
        // VERY IMPORTANT, when the directive is destroyed, we must unsubscribe from all events for canvas
        // so, in this case, the events will not be duplicated
        $('body').off('click', '.bcPaint-palette-color') // Event to change color
        $('body').off('click', '#bcPaint-reset') // Event to Reset
        $('body').off('click', '#bcPaint-export') // Event to Save
      })

      // All events for canvas
      $(document).ready(function () {
        // Event to change color
        $('body').on('click', '.bcPaint-palette-color', function () {
          $(this).parent().find('.selected').removeClass('selected')
          $(this).addClass('selected')
          $.fn.bcPaint.setColor($(this).css('background-color'))
        })

        // Event to Reset
        $('body').on('click', '#bcPaint-reset', function () {
          $.fn.bcPaint.clearCanvas()
        })

        // Event to Save
        $('body').on('click', '#bcPaint-export', function () {
          $.fn.bcPaint.export()
        })
      })
      ;(function ($) {
        /**
         * Private variables
         **/
        var isDragged = false,
          templates = {
            container: $('<div class="row" id="bcPaint-container"></div>'),
            header: $('<div class="col-12" id="bcPaint-header"></div>'),
            palette: $(
              '<div class="col-12 text-center" id="bcPaint-palette"><h2>Color Palette</h2></div>',
            ),
            color: $('<div class="bcPaint-palette-color"></div>'),
            canvasContainer: $(
              '<div class="col-12" id="bcPaint-canvas-container"></div>',
            ),
            canvasPane: $('<canvas id="bcPaintCanvas"></canvas>'),
            bottom: $(
              '<div class="col-12 buttons-center" id="bcPaint-bottom"></div>',
            ),
            buttonReset: $(
              '<button type="button" class="btn-default-general btn-default-secondary" id="bcPaint-reset">Clear</button>',
            ),
            buttonSave: $(
              '<button type="button" class="btn-default-general btn-default-primary" id="bcPaint-export">Save</button>',
            ),
          },
          paintCanvas,
          paintContext

        /**
         * Get XY position from event
         **/
        function getPositionXY(e) {
          var pos = {
            x: 0,
            y: 0,
          }

          if (e && e.type) {
            if (e.type == 'touchstart' || e.type == 'touchmove') {
              // Mobile device
              if (e.touches && e.touches.length) {
                var touch = e.touches[0]
                var { x, y, width, height } = e.target.getBoundingClientRect()
                pos.x = ((touch.clientX - x) / width) * e.target.offsetWidth
                pos.y = ((touch.clientY - y) / height) * e.target.offsetHeight
              }
            } else {
              // Computer device
              pos.x = e.offsetX || 0
              pos.y = e.offsetY || 0
            }
          }

          return Object.assign({}, pos)
        }

        /**
         * Assembly and initialize plugin
         **/
        $.fn.bcPaint = function (options) {
          return this.each(function () {
            var rootElement = $(this),
              colorSet = $.extend({}, $.fn.bcPaint.defaults, options),
              defaultColor =
                rootElement.val().length > 0
                  ? rootElement.val()
                  : colorSet.defaultColor,
              container = templates.container.clone(),
              palette = templates.palette.clone(),
              canvasContainer = templates.canvasContainer.clone(),
              canvasPane = templates.canvasPane.clone(),
              bottom = templates.bottom.clone(),
              buttonReset = templates.buttonReset.clone(),
              buttonSave = templates.buttonSave.clone(),
              color

            // assembly pane
            rootElement.append(container)
            container.append(canvasContainer)
            container.append(bottom)
            canvasContainer.append(canvasPane)
            bottom.append(buttonReset)
            bottom.append(buttonSave)

            // assembly color palette
            $.each(colorSet.colors, function (i) {
              color = templates.color.clone()
              color.css(
                'background-color',
                $.fn.bcPaint.toHex(colorSet.colors[i]),
              )
              palette.append(color)
            })

            // set canvas pane width and height -> (2:1)
            var bcCanvas = rootElement.find('canvas')
            var bcCanvasContainer = rootElement.find(
              '#bcPaint-canvas-container',
            )
            bcCanvas.attr('width', bcCanvasContainer.width())
            bcCanvas.attr('height', bcCanvasContainer.width() / 2) // or bcCanvasContainer.height()

            // get canvas pane context
            paintCanvas = document.getElementById('bcPaintCanvas')
            paintContext = paintCanvas.getContext('2d')

            // set color
            $.fn.bcPaint.setColor(defaultColor)

            // bind mouse actions
            paintCanvas.onmousedown = $.fn.bcPaint.onEventStart
            paintCanvas.onmouseup = $.fn.bcPaint.onEventEnd
            paintCanvas.onmousemove = $.fn.bcPaint.onEventMove

            // bind touch actions
            paintCanvas.ontouchstart = $.fn.bcPaint.onEventStart
            paintCanvas.ontouchend = $.fn.bcPaint.onEventEnd
            paintCanvas.ontouchmove = $.fn.bcPaint.onEventMove

            // Prevent scrolling on touch event
            document.body.addEventListener(
              'touchstart',
              function (e) {
                if (e.target == paintCanvas) {
                  e.preventDefault()
                }
              },
              { passive: false },
            )
            document.body.addEventListener(
              'touchend',
              function (e) {
                if (e.target == paintCanvas) {
                  e.preventDefault()
                }
              },
              { passive: false },
            )
            document.body.addEventListener(
              'touchmove',
              function (e) {
                if (e.target == paintCanvas) {
                  e.preventDefault()
                }
              },
              { passive: false },
            )
          })
        }

        /**
         * Extend plugin
         **/
        $.extend(true, $.fn.bcPaint, {
          /**
           * Remove pane
           */
          clearCanvas: function () {
            paintCanvas.width = paintCanvas.width
            $scope.clearEvent()
          },

          /**
           * Event handler for touch and mouse
           **/
          onEventStart: function (e) {
            isDragged = true

            var pos = getPositionXY(e)
            var posX = pos ? pos.x || 0 : 0
            var posY = pos ? pos.y || 0 : 0

            paintContext.lineWidth = 4
            paintContext.beginPath()
            paintContext.moveTo(posX, posY)
            e.preventDefault()
          },

          /**
           * Event handler for touch and mouse
           **/
          onEventEnd: function (e) {
            isDragged = false
            e.preventDefault()
          },

          /**
           * Event handler for touch and mouse
           **/
          onEventMove: function (e) {
            if (isDragged) {
              var pos = getPositionXY(e)
              var posX = pos ? pos.x || 0 : 0
              var posY = pos ? pos.y || 0 : 0

              paintContext.lineWidth = 4
              paintContext.lineTo(posX, posY)
              paintContext.stroke()
              e.preventDefault()
            }
          },

          /**
           * Set selected color
           **/
          setColor: function (color) {
            paintContext.strokeStyle = $.fn.bcPaint.toHex(color)
          },

          /**
           * Save image
           */
          export: function () {
            function b64toBlob(dataURI) {
              var byteString = atob(dataURI.split(',')[1])
              var ab = new ArrayBuffer(byteString.length)
              var ia = new Uint8Array(ab)

              for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i)
              }
              return new Blob([ab], { type: 'image/png' })
            }

            function getFileNameByDate() {
              var date = new Date()
              var part1 =
                date.getFullYear() +
                '-' +
                (date.getMonth() + 1) +
                '-' +
                date.getDate()
              var part2 =
                date.getHours() +
                '-' +
                date.getMinutes() +
                '-' +
                date.getSeconds() +
                '-' +
                date.getMilliseconds()
              var result = part1 + '_' + part2
              return result ? result : ''
            }

            var base64 = paintCanvas.toDataURL('image/png')
            var blob = b64toBlob(base64)
            var fileOfBlob = new File(
              [blob],
              'image_' + getFileNameByDate() + '.png',
              { type: 'image/png' },
            )

            $scope.saveEvent({ imgData: fileOfBlob })
          },

          /**
           * Convert color to HEX value
           **/
          toHex: function (color) {
            // check if color is standard hex value
            if (color.match(/[0-9A-F]{6}|[0-9A-F]{3}$/i)) {
              return color.charAt(0) === '#' ? color : '#' + color
              // check if color is RGB value -> convert to hex
            } else if (
              color.match(
                /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/,
              )
            ) {
              var c = [
                  parseInt(RegExp.$1, 10),
                  parseInt(RegExp.$2, 10),
                  parseInt(RegExp.$3, 10),
                ],
                pad = function (str) {
                  if (str.length < 2) {
                    for (var i = 0, len = 2 - str.length; i < len; i++) {
                      str = '0' + str
                    }
                  }
                  return str
                }
              if (c.length === 3) {
                var r = pad(c[0].toString(16)),
                  g = pad(c[1].toString(16)),
                  b = pad(c[2].toString(16))
                return '#' + r + g + b
              }
              // else do nothing
            } else {
              return false
            }
          },
        })

        /**
         * Default color set
         **/
        $.fn.bcPaint.defaults = {
          // default color
          defaultColor: '000000',

          // default color set
          colors: [
            '000000',
            '444444',
            '999999',
            'DDDDDD',
            '#e83e8c',
            '#dc3545',
            '#fd7e14',
            '#ffc107',
            '#28a745',
            '#20c997',
            '#6f42c1',
            '#007bff',
          ],

          // extend default set
          addColors: [],
        }
      })(jQuery)

      /**
       * Initial bcPaint
       **/
      $('#bcPaint').bcPaint()
    },
  }
}
